import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import scrollIntoView from 'scroll-into-view-if-needed';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import styled, { withTheme } from 'styled-components';
import { capfl, canUseDOM } from 'common/utils';
import { sprintf } from 'sprintf-js';

import {
  getPageDataSelector,
  getPageIsLoadingSelector,
  getListingLayoutSelector
} from 'common/selectors/page';

import { toggleFilters } from 'common/actions/AppActions';

import { fireGTMEvent, getGTMCategoryList } from 'common/utils/gtm';
import {
  PRODUCT_VIEW,
  PAGE_VIEW
} from 'common/constants/GTMConstants';
import { LISTING_LAYOUT_ROWS } from 'common/constants/SiteConstants';

import { withCssUnit } from 'common/components/styleguide/utils';
import {
  BlockTransparent,
  BlockFlex
} from 'common/components/styleguide/grid/Block';
import Button from 'common/components/styleguide/Button';
import Column from 'common/components/styleguide/grid/Column';
import Container from 'common/components/styleguide/grid/Container';
import Row from 'common/components/styleguide/grid/Row';
const ButtonRouteLink = loadable(() =>
  import('common/components/_base/ButtonRouteLink')
);

import Breadcrumbs from 'common/components/_partials/breadcrumbs/index';

import loadable from '@loadable/component';
const CategoryHeader = loadable(() => import('common/blocks/category/header'));
const SelectSort = loadable(() =>
  import('common/components/category/breadcrumbsWithSort/SelectSort')
);
const LayoutSwitcher = loadable(() =>
  import('common/components/category/listing/_default/LayoutSwitcher')
);
import { Headline1 } from 'common/components/styleguide/Headline';
const BoxCard = loadable(() =>
  import(`common/pages/product/freshbox/freshboxCard`)
);
const RestaurantCard = loadable(() =>
  import(`common/pages/product/freshbox/freshboxCardRestaurant`)
);
const ProductCard = loadable(() => import(`common/blocks/product/card`));

import Filters from 'common/components/category/filters/_default';
import ActiveFilters from 'common/components/category/filters/_default/Active';
import Pagination from 'common/components/category/PaginationWithPerPage';
import NotFound from 'common/components/errors/404';
import loader from 'assets/images/loader.svg';

import SS from 'common/pages/_style/index';

const S = {};

S.CategoryWrapper = styled.div`
  background-color: transparent;
  width: 100%;
`;

S.WrapperOrdering = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;

  // @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
  //   flex-direction: row;
  //   justify-content: end;
  //   align-items: right;
  // }
`;

S.WrapperItem = styled.div`
  display: flex;
`;

S.ButtonWrapper = styled.div`
  margin-bottom: 15px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: none;
  }
`;

S.Button = styled(Button)`
  background: ${({ theme }) =>
    _.get(theme, 'filters.showFiltersButton.background')};
  font-size: ${({ theme }) =>
    _.get(theme, 'filters.showFiltersButton.fontSize')};
  color: ${({ theme }) => _.get(theme, 'filters.showFiltersButton.color')};
  font-weight: ${({ theme }) =>
    _.get(theme, 'filters.showFiltersButton.fontWeight')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

S.ButtonRouteLink = styled(ButtonRouteLink)`
  display: flex;
  height: 100%;
`;

S.BoxHeaderWrapper = styled(({ variant, children, ...props }) => {
  return <BlockFlex {...props}>{children}</BlockFlex>;
})`
  @media (max-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    height: auto;
    min-height: auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
`;

const BoxCategory = ({ gotProducts, title, products, subcategories, GTMCategoryList }) => {
  return (
    <Row>
      {gotProducts ? (
        <Column size={{ xs: 12 }}>
          <S.BoxHeaderWrapper marginConfig={{ bottom: true }}>
            <Headline1>{title}</Headline1>
            {!_.isEmpty(subcategories) ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch'
                }}
              >
                {_.map(subcategories, (child, index) => {
                  return (
                    <S.ButtonRouteLink
                      key={`box-subcategory-${_.get(child, 'id', index)}`}
                      // href={child.externalUrl}
                      route="category"
                      params={{ id: child.urlName }}
                      enableBackground={false}
                      outline={index == 0 || index % 2 == 0 ? true : false}
                      component={'a'}
                      buttonSize={'normal'}
                      buttonType={'primary'}
                      target={child.openInNewWindow ? '_blank' : ''}
                    >
                      {child.name}
                    </S.ButtonRouteLink>
                  );
                })}
              </div>
            ) : null}
          </S.BoxHeaderWrapper>
          <Row>
            {_.map(products, (product, index) => {
              return (
                <Column
                  size={
                    index == 0 || index % 3 == 0
                      ? { xs: 12 }
                      : { xs: 12, md: 6 }
                  }
                  key={'products-box-listing-column-' + index}
                  paddingUseBottom={true}
                >
                  <BoxCard
                    data={product}
                    variant={index == 0 || index % 3 == 0 ? 3 : 2}
                    GTMCategoryList={GTMCategoryList}
                  />
                </Column>
              );
            })}
          </Row>
        </Column>
      ) : (
        <Column size={{ xs: 12 }}>
          <NotFound />
        </Column>
      )}
    </Row>
  );
};

const RestaurantCategory = ({
  gotProducts,
  gotFilters,
  title,
  products,
  activeLayout,
  GTMCategoryList
}) => {
  return (
    <Row>
      {gotProducts ? (
        <Column size={{ xs: 12 }}>
          <CategoryHeader title={title} />

          {/* <Filters /> */}

          {/* {categoryData && gotFilters ? (
          <S.ButtonWrapper>
            <S.Button onClick={this.onToggleFiltersMenuClick} fullWidth>
              {capfl(t('show filters'))}
              <Icon className={ICON_CHEVRON_DOWN} />
            </S.Button>
          </S.ButtonWrapper>
        ) : (
          ''
        )} */}

          {/* <BlockTransparent marginConfig={{ bottom: true }}>
            <Row>
              <Column size={{ xs: 12, md: 7, lg: 9 }}>
                <ActiveFilters />
              </Column>
              <Column size={{ xs: 12, md: 5, lg: 3 }}>
                <S.WrapperOrdering>
                  <S.WrapperItem>
                    <SelectSort />
                  </S.WrapperItem>
                  <S.WrapperItem>
                    <LayoutSwitcher />
                  </S.WrapperItem>
                </S.WrapperOrdering>
              </Column>
            </Row>
          </BlockTransparent> */}

          <Row>
            {_.map(products, (product, i) => {
              return (
                <Column
                  size={
                    LISTING_LAYOUT_ROWS == activeLayout
                      ? { xs: 12 }
                      : { xs: 6, sm: 4 }
                  }
                  key={'restaurant-listing-column-' + i}
                  paddingUseBottom={true}
                >
                  <RestaurantCard data={product} layout={activeLayout} GTMCategoryList={GTMCategoryList} />
                </Column>
              );
            })}
          </Row>
        </Column>
      ) : (
        <Column size={{ xs: 12 }}>
          <NotFound />
        </Column>
      )}
    </Row>
  );
};

const ProductCategory = ({
  gotProducts,
  gotFilters,
  title,
  products,
  activeLayout,
  GTMCategoryList
}) => {
  return (
    <Row>
      {gotProducts ? (
        <Column size={{ xs: 12 }}>
          <CategoryHeader title={title} />

          {/* <Filters /> */}

          {/* {categoryData && gotFilters ? (
          <S.ButtonWrapper>
            <S.Button onClick={this.onToggleFiltersMenuClick} fullWidth>
              {capfl(t('show filters'))}
              <Icon className={ICON_CHEVRON_DOWN} />
            </S.Button>
          </S.ButtonWrapper>
        ) : (
          ''
        )} */}

          <BlockTransparent marginConfig={{ bottom: true }}>
            <Row>
              <Column size={{ xs: 12, md: 7, lg: 9 }}>
                <ActiveFilters />
              </Column>
              <Column size={{ xs: 12, md: 5, lg: 3 }}>
                <S.WrapperOrdering>
                  <S.WrapperItem>
                    <SelectSort />
                  </S.WrapperItem>
                  <S.WrapperItem>
                    <LayoutSwitcher />
                  </S.WrapperItem>
                </S.WrapperOrdering>
              </Column>
            </Row>
          </BlockTransparent>

          <Row>
            {_.map(products, (product, i) => {
              return (
                <Column
                  size={
                    LISTING_LAYOUT_ROWS == activeLayout
                      ? { xs: 12 }
                      : { xs: 6, sm: 4, md: 3, lg: 3 }
                  }
                  key={'products-listing-column-' + i}
                  paddingUseBottom={true}
                >
                  <ProductCard
                    data={product}
                    showTitleOnTop={false}
                    showBrandOnTop={false}
                    showBrand={true}
                    showLabels={true}
                    imageWidth={420}
                    imageHeight={440}
                    lazyload={false}
                    layout={activeLayout}
                    GTMCategoryList={GTMCategoryList}
                  />
                </Column>
              );
            })}
          </Row>
        </Column>
      ) : (
        <Column size={{ xs: 12 }}>
          <NotFound />
        </Column>
      )}
    </Row>
  );
};

const CategoryContentFactory = ({
  categoryData,
  title,
  gotProducts,
  gotFilters,
  activeLayout,
  products,
  GTMCategoryList
}) => {

  if (_.get(categoryData, 'description', '-').indexOf('#box-style#') >= 0) {
    return (
      <BoxCategory
        gotProducts={gotProducts}
        title={title}
        products={products}
        subcategories={_.get(categoryData, 'childCategories', null)}
        GTMCategoryList={GTMCategoryList}
      />
    );
  }

  if (_.get(categoryData, 'urlName', '-').indexOf('fresh-food') >= 0) {
    return (
      <RestaurantCategory
        gotFilters={gotFilters}
        gotProducts={gotProducts}
        title={title}
        products={products}
        activeLayout={activeLayout}
        GTMCategoryList={GTMCategoryList}
      />
    );
  }

  return (
    <ProductCategory
      gotFilters={gotFilters}
      gotProducts={gotProducts}
      title={title}
      products={products}
      activeLayout={activeLayout}
      GTMCategoryList={GTMCategoryList}
    />
  );
};

class Category extends PureComponent {
  constructor(props) {
    super(props);
    this.listingSectionRef = React.createRef();
    this.onToggleFiltersMenuClick = this.onToggleFiltersMenuClick.bind(this);
  }
  scrollToListing = () => {
    if (canUseDOM()) {
      const node = ReactDOM.findDOMNode(this.listingSectionRef.current);
      if (node) {
        scrollIntoView(node, {
          scrollMode: 'if-needed',
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        });
      }
    }
  };
  onToggleFiltersMenuClick(e) {
    e.preventDefault();
    const { toggleFiltersMenu } = this.props;
    toggleFiltersMenu();
  }
  componentDidMount() {
    const {
      products,
      gotActiveFilters,
      categoryData
    } = this.props;
    const list = getGTMCategoryList(categoryData, gotActiveFilters);
    let additionalData = null;
    if (_.get(categoryData, 'search', '')) {
      additionalData = { searchString: _.get(categoryData, 'search', null) };
    }
    fireGTMEvent(PRODUCT_VIEW, products, list, additionalData);
  }
  componentDidUpdate(prevProps) {
    const prevProducts = _.get(prevProps, 'products', {});
    const {
      products,
      gotActiveFilters,
      categoryData
    } = this.props;
    if (JSON.stringify(prevProducts) !== JSON.stringify(products)) {
      const list = getGTMCategoryList(categoryData, gotActiveFilters);
      let additionalData = null;
      if (_.get(categoryData, 'search', '')) {
        additionalData = { searchString: _.get(categoryData, 'search', null) };
      }
      fireGTMEvent(PAGE_VIEW);
      fireGTMEvent(PRODUCT_VIEW, products, list, additionalData);
    }
  }
  render() {
    const {
      t,
      categoryData,
      gotFilters = false,
      gotProducts = false,
      gotPagination = false,
      gotActiveFilters = false,
      isLoading = false,
      products,
      activeLayout
    } = this.props;
    const GTMCategoryList = getGTMCategoryList(categoryData, gotActiveFilters);
    const search = _.get(categoryData, 'search', null);

    let title = '';
    if (search) {
      title = sprintf(
        '%1$s: %2$s',
        capfl(t('searching phrase')),
        decodeURIComponent(search)
      );
    } else {
      title = _.get(categoryData, 'name', '');
    }

    return (
      <S.CategoryWrapper ref={this.listingSectionRef}>
        <Container>
          <Row>
            <Column size={{ xs: 12 }}>
              <BlockTransparent
                marginConfig={{ bottom: true, top: true }}
                paddingConfig={{}}
                customStyle={'font-size: 0.9em'}
              >
                <Breadcrumbs withSameLevels={false} />
              </BlockTransparent>
            </Column>
          </Row>

          <CategoryContentFactory
            categoryData={categoryData}
            gotFilters={gotFilters}
            gotProducts={gotProducts}
            title={title}
            products={products}
            activeLayout={activeLayout}
            GTMCategoryList={GTMCategoryList}
          />

          {gotPagination ? (
            <BlockTransparent
              marginConfig={{ bottom: true, top: true }}
              paddingConfig={{}}
            >
              <Pagination afterClick={this.scrollToListing} />
            </BlockTransparent>
          ) : (
            ''
          )}
        </Container>
        {isLoading ? (
          <SS.Overlay>
            <img src={loader} alt="loader" />
          </SS.Overlay>
        ) : (
          ''
        )}
      </S.CategoryWrapper>
    );
  }
}

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const getPageIsLoading = getPageIsLoadingSelector();
  const getListingLayout = getListingLayoutSelector();
  return (state, props) => {
    const pageData = getPageData(state, props);
    const isLoading = getPageIsLoading(state, props);
    const activeFilters = _.get(pageData, 'activeFilters');
    return {
      isLoading,
      categoryData: _.get(pageData, 'data'),
      gotProducts: !_.isEmpty(_.get(pageData, 'products')),
      products: _.get(pageData, 'products'),
      breadcrumbs: _.get(pageData, 'breadcrumbs.categorical', {}),
      gotFilters: !_.isEmpty(_.get(pageData, 'filter')),
      gotActiveFilters: !_.isEmpty(activeFilters),
      gotPagination: !_.isEmpty(_.get(pageData, 'pagination')),
      activeLayout: getListingLayout(state, props)
    };
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleFiltersMenu: () => {
      dispatch(toggleFilters());
    }
  };
};

const CategoryConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(Category);

export default withTranslation()(withTheme(CategoryConnected));
